<template>
  <a
    :href="feedItem.url"
    v-analytics="feedEventlabel"
    :data-gtm-related-number="relatedNumber"
    :data-gtm-logic-id="feedItem.logic_id"
    :data-gtm-feed-id="feedId"
    :data-gtm-order-position="orderPosition"
    :data-gtm-creation-id="creationId"
    @click="onClick"
  >
    <div class="global-feed-list-img" :class="{'global-feed-is-loading':!imageLoaded}">
      <figure>
        <image-viewer :src="feedItem.thumbnail" :alt-src="noimage" :async="true" @load="onLoad"/>
      </figure>
    </div>
    <div class="global-feed-list-txt">
      <p class="global-feed-list-title">{{feedItem.title}}</p>
      <div v-if="typeof feedItem ==='object' && typeof feedItem.recommend_avg === 'number' && feedItem.recommend_avg >= 0 && feedItem.recommend_avg <=7" class="c-global-feed-list-rating-box">
        <span :class="starClass(feedItem.recommend_avg)">
          <span class="c-global-feed-list-rating-star"></span>
          <span v-if="feedItem.logic_id === 'Logic-BFProduct'" class="c-global-feed-list-rating-point">{{feedItem.recommend_avg.toFixed(1)}}</span>
          <span v-if="feedItem.logic_id !== 'Logic-BFProduct'" class="c-global-feed-list-rating-point">{{feedItem.recommend_avg}}</span>
        </span>
        <span v-if="typeof feedItem ==='object' && typeof feedItem.review_count === 'number' && feedItem.review_count >= 0" class="c-global-feed-list-rating-number">{{feedItem.review_count}}件</span>
      </div>
      <p v-if="feedItem.text" class="global-feed-list-sub">{{feedItem.text}}</p>
      <p v-if="feedItem.hashtag" class="global-feed-hash-tag">{{feedItem.hashtag}}</p>
    </div>
  </a>
</template>

<script>
import Config        from '../../../libs/config';
import ImageViewer   from '@istyle-inc/media-component/components/image-viewer';
import Trackinghatch from '../../../libs/trackinghatch';
import Viewability   from '../../../libs/viewability';
import analytics     from '../../../directives/analytics';

export default {
  name      : 'feed-item',
  directives: {
    analytics,
  },
  components: {
    ImageViewer,
  },
  data: function() {
    return {
      noimage    : Config.GLOBAL_FEED_NOIMAGE,
      imageLoaded: false,
    };
  },
  props: {
    feedParam: {
      type    : Object,
      required: true,
    },
    feedItem: {
      type    : Object,
      required: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      const oav = new Viewability();
      oav.checkViewability(this.$el, (check) => {
        if (check.viewabiltyStatus) {
          this.sendTrahatchRequest(this.$el);
        }
      });
    });
  },
  computed: {
    // ラベル有無によってイベントラベル設定
    feedEventlabel: function() {
      return {
        category: 'globalnavi_feed',
        label   : `${this.contentRelatedId}_${this.feedItem.url}_${this.memberProfileId}_${this.creationId}`,
      };
    },
    contentRelatedId: function() {
      return `${this.feedItem.hashtag ? 'related1' : 'related0'}_${this.feedItem.logic_id}_${this.feedItem.content_id}`;
    },
    memberProfileId: function() {
      return `${this.feedParam.istyle_id ? this.feedParam.istyle_id : 'null'}_${this.feedParam.visitor_id ? this.feedParam.visitor_id : 'null'}`;
    },
    creationId: function() {
      return `${this.feedItem.creation.id ? this.feedItem.creation.id : 'null'}`;
    },
    relatedNumber: function() {
      return this.feedItem.hashtag ? 'related1' : 'related0';
    },
    feedId: function() {
      return this.feedItem.content_id ? this.feedItem.content_id.split('_')[0] : undefined;
    },
    orderPosition: function() {
      return this.feedItem.content_id ? this.feedItem.content_id.split('_')[1] : undefined;
    },
  },
  methods: {
    // ipfeed.impression トラハチへ送るだけ
    sendTrahatchRequest: function(el) {
      const trackinghatch = new Trackinghatch(el.ownerDocument);
      // impression Eventを送る
      trackinghatch.sendEvent("ipfeed.impression", this.contentRelatedId, this.feedItem, this.feedParam);
    },
    onLoad: function() {
      this.imageLoaded = true;
    },
    starClass: function(recommend_avg) {
      // 小数第一位を取得
      const recommendAvgDicimal = recommend_avg.toString().split('.')[1];
      if (recommendAvgDicimal) {
        if ( (1 <= recommendAvgDicimal) && (recommendAvgDicimal <= 4) ) {
          // 評価点が n.1 ~ n.4 の場合 -> 星n個表示
          return 'c-global-feed-list-rating is-rating-' + Math.floor(recommend_avg).toString();
        } else {
          // 評価点が n.5 ~ n.9 の場合 -> 星n.5個表示
          return 'c-global-feed-list-rating is-rating-' + Math.floor(recommend_avg).toString() + '_5';
        }
      }
      return 'c-global-feed-list-rating is-rating-' + recommend_avg.toString();
    },
    onClick: function(){
      let el = this.$el;
      const trackinghatch = new Trackinghatch(el.ownerDocument);
      // click Eventを送る
      trackinghatch.sendEvent("ipfeed.click", this.contentRelatedId, this.feedItem, this.feedParam);
    },
  },
};
</script>
